import React from 'react'

import { Box, Button, Icon, Text } from '@factorialco/deprecated-design-system'
import { LineChart } from '@factorialco/f0-react'
import { ExpensesReportsPageQuery } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'
import MoneyWithCurrency from 'modules/core/lib/money'

interface ExpensablesByMonthChartProps {
  data?: ExpensesReportsPageQuery
  currency: string
  onEmptyStateClick?: () => void
}

const ExpensablesByMonthChart: React.FC<ExpensablesByMonthChartProps> = ({
  data,
  currency,
  onEmptyStateClick,
}) => {
  const renderEmptyState = () => {
    return (
      <Box width="full" height="s400" minHeight="s400" justifyContent="center" alignItems="center">
        <Box flexDirection="column" gap="s16" alignItems="center" textAlign="center">
          <Icon.Large icon="calendar" color="grey700" />
          <Text.Header2>
            {i18n.t('expenses_v2.reports.expenses_by_month.empty_state.title')}
          </Text.Header2>
          <Box flexDirection="column" gap="s2">
            <Text.Normal color="grey800">
              {i18n.t('expenses_v2.reports.expenses_by_month.empty_state.description1')}
            </Text.Normal>
            <Text.Normal color="grey800">
              {i18n.t('expenses_v2.reports.expenses_by_month.empty_state.description2')}
            </Text.Normal>
          </Box>
          <Button type="secondary" onClick={onEmptyStateClick}>
            {i18n.t('expenses_v2.reports.expenses_by_month.empty_state.cta')}
          </Button>
        </Box>
      </Box>
    )
  }

  const expensablesByMonthData = data?.expenses.expensablesByMonthsConnection.nodes ?? []

  if (expensablesByMonthData.length < 3) return renderEmptyState()

  const chartData = expensablesByMonthData.map((expense) => ({
    label: new Date(expense.year, expense.month - 1).toLocaleDateString(undefined, {
      month: 'long',
      year: 'numeric',
    }),
    values: {
      expenses: Number(expense.totalAmount),
    },
  }))

  return (
    <Box width="full" height="s400" minHeight="s400">
      <LineChart
        data={chartData}
        lineType="linear"
        dataConfig={{
          expenses: {
            color: 'categorical-1',
            label: i18n.t('expenses_v2.reports.expenses_by_month.chart_tooltip'),
          },
        }}
        xAxis={{
          tickFormatter: (value: string) => value,
        }}
        yAxis={{
          hide: false,
          tickFormatter: (value: string) =>
            MoneyWithCurrency({ amount: parseInt(value), currency, locale: 'en' }),
        }}
      />
    </Box>
  )
}

export default ExpensablesByMonthChart
